module.exports = __webpack_public_path__ + "static/model-headphones-08ce0846c51fa24a6b4e7a7ed5289d92.png";